import { render, staticRenderFns } from "./MenuSelect.vue?vue&type=template&id=47d5f078&"
import script from "./MenuSelect.vue?vue&type=script&lang=js&"
export * from "./MenuSelect.vue?vue&type=script&lang=js&"
import style0 from "./MenuSelect.vue?vue&type=style&index=0&id=47d5f078&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports